import React from "react"
import axios from 'axios';
import I18n from 'i18n-js';
import './translations.js';
import { HorseSearchForm } from './search/HorseSearchForm.jsx';
import { ErrorMessage } from './shared/ErrorMessage.jsx';

class RegistrantCreateHorseWizard extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      hasMemberships: true,
      errorMessage: false,
      showSearchForm: false,
      formLoader: null,
      horseData: '',
      lastName: '',
      usef: '',
      fei: '',
      ec: ''
    };
    this.handleAcountOptionChange = this.handleAcountOptionChange.bind(this);
    this.handleMembershipCheckboxChange = this.handleMembershipCheckboxChange.bind(this);
    this.checkUserMembership = this.checkUserMembership.bind(this);
    this.showSearchForm = this.showSearchForm.bind(this);
    this.goBackToPeople = this.goBackToPeople.bind(this);
    this.goBackFromSearchForm = this.goBackFromSearchForm.bind(this);
    this.acceptAlphanumeric = this.acceptAlphanumeric.bind(this);
    I18n.locale = this.props.locale;

  }

  handleAcountOptionChange(e) {
    this.setState({ selectedOption: e.target.value });
  }

  handleMembershipCheckboxChange(e) {
    this.setState({ hasMemberships: !e.target.checked , errorMessage: ''});
  }

  goBackToPeople() {
    if (!this.state.formLoader) {
      window.location = "/registrants/" + this.props.createUserData.registrant.id +"/horses";
    }
  }

  goBackFromSearchForm() {
    this.setState({ showSearchForm: false, hasMemberships: true, errorMessage: '' });
  }

  updateExistingUserInfo(horse_data) {
    if (horse_data.already_exists) {
      var message = I18n.t("horse.horse_already_exists", { horse_name: horse_data.name, exhibitor_name: horse_data.registrant_name } );
      this.setState({ errorMessage: message });
    } else if (horse_data.usef_valid && horse_data.fei_valid && horse_data.ec_valid) {
      this.setState({ 
        errorMessage: false,
        horseData: horse_data,
        usef: this.usef_membership_number.value,
        fei: this.fei_membership_number.value,
        ec: this.ec_membership_number.value
         })
      this.showSearchForm();
    } else {
      var messageBody = I18n.t("horse.enter_valid_number");
      var message = "";
      if (!horse_data.usef_valid) {
        message += I18n.t("horse.usef") + messageBody;
      }
      if (!horse_data.fei_valid) {
        message += I18n.t("horse.fei") + messageBody;
      }
      if (!horse_data.ec_valid) {
        message += I18n.t("horse.ec") + messageBody;
      }
      this.setState({ errorMessage: message });
    }
    this.setState({ formLoader: null});
  }

  showSearchForm() {
    this.setState({ showSearchForm: true, formLoader: null });
  }

  acceptAlphanumeric(e) {
    const re = /[0-9a-zA-Z]+/g;
    if (!re.test(e.key)) {
      e.preventDefault();
    }
  }

  checkUserMembership(e) {
    e.preventDefault();
    this.setState({ formLoader: "loader-box"});
    if (!this.state.hasMemberships) return this.showSearchForm();
    axios.post('/api/v1/equine_association/existing_horse_bulk_check', {
      usef_membership_number: this.usef_membership_number.value,
      ec_membership_number: this.ec_membership_number.value,
      fei_membership_number: this.fei_membership_number.value
      })
      .then(response => this.updateExistingUserInfo(response.data))
      .catch(error => this.setState({ errorMessage: I18n.t("exhibitor.ea_try_none"),
                                      formLoader: null}));
  }

  render () {
    return (
      <div className="form-horizontal">
        {!this.state.showSearchForm ?
          <div>
            <h2>{I18n.t("exhibitor.create_horse_wizard")}</h2>
            { this.state.errorMessage ? 
              <ErrorMessage message={this.state.errorMessage} />
              : undefined
            }
            <p>{ I18n.t("exhibitor.they_have_memberships_prompt") }</p>
            <div className="outer-box">
              <div className={this.state.formLoader}>
                <div className={this.state.formLoader ? "loader" : ""}/>
                <form onSubmit={this.checkUserMembership}>
                  <div className="row">
                    <div className="control-group string optional usef">
                      <label className="string optional control-label">{I18n.t("equine_association.usef")}</label>
                      <div className="controls">
                        <input className="string optional" type="text" onKeyPress={(e) => this.acceptAlphanumeric(e)} ref={input => this.usef_membership_number = input} disabled={!this.state.hasMemberships || this.state.formLoader}/>
                      </div>
                    </div>
                    <div className="control-group string optional fei">
                      <label className="string optional control-label">Fédération Équestre Internationale</label>
                      <div className="controls">
                        <input className="string optional" type="text" onKeyPress={(e) => this.acceptAlphanumeric(e)} ref={input => this.fei_membership_number = input} disabled={!this.state.hasMemberships || this.state.formLoader}/>
                      </div>
                    </div>
                    <div className="control-group string optional ec">
                      <label className="string optional control-label">{I18n.t("equine_association.ec")}</label>
                      <div className="controls">
                        <input className="string optional" type="text" onKeyPress={(e) => this.acceptAlphanumeric(e)} ref={input => this.ec_membership_number = input} disabled={!this.state.hasMemberships || this.state.formLoader}/>
                      </div>
                    </div>
                    <div className="control-group string optional none">
                      <label className="string optional control-label">{I18n.t("none")}</label>
                      <div className="controls">
                        <input type="checkbox" disabled={this.state.formLoader} onChange={this.handleMembershipCheckboxChange}/>
                      </div>
                    </div>
                    <a className="btn btn-success" onClick={this.goBackToPeople} disabled={this.state.formLoader}>{I18n.t("back_button_label")}</a>
                    <span> </span>
                    <input className="btn btn-success" type="submit" disabled={this.state.formLoader} value={I18n.t("next_button_label")}/>
                  </div>
                </form>
              </div>
            </div>
          </div>
          : 
          <HorseSearchForm type={ this.state.selectedOption }
            createUserData={ this.props.createUserData} 
            horseData={this.state.horseData}
            skipSearch={this.state.hasMemberships}
            goBack={this.goBackFromSearchForm}
            usef={this.state.usef}
            ec={this.state.ec}
            fei={this.state.fei}
            />
        }
      </div>
    );
  }
}

export default RegistrantCreateHorseWizard
